import { AssetTypes } from 'constants/alo';

export const icon = (node: Hierarchy.IHierarchyItem) => {
    switch (node.category) {
        case AssetTypes.Completion:
            let badge;
            let type = 'AL-icon--well';

            if (node.transStatus === 'ONLINE') {
                badge = 'badge-online';
            } else if (node.transStatus === 'OFFLINE') {
                badge = 'badge-offline';
            } else {
                badge = 'badge-hibernating';
            }

            if (node.locationId > 0) {
                type = 'AL-icon--zedi';
            }

            if (node.locationId === -1) {
                type = 'AL-icon--pi';
            }

            return `${type} ${badge}`;

        case AssetTypes.Facility:
            return 'AL-icon--pad';
        case AssetTypes.Field:
            return 'AL-icon--field';
        case AssetTypes.SCB:
            return 'AL-icon--gateway';
        default:
            return null;
    }
}
